
const formatDate = (date) => {
  if (!date) return '';
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const d = new Date(date);
  return  d.toLocaleDateString('en-CA', options);
}

export default formatDate;